import { upcMapper } from '@nuxt-common/media-card-large/app/composables/useUpc';
import type { MemberProductMapProduct } from '~~/shared/globalTypes/product';

export default function UpcParser(product: Product, latchkeyProduct?: MemberProductMapProduct) {
  const { upcMap } = latchkeyProduct?.traits?.traitsMaps || {};

  const upcs = Object.fromEntries(Object.entries(product.relationships.upcs || {}).map(([key, value]) => [key, upcMapper(value)]));

  return {
    upcMap,
    upcs,
  };
}
